import { createContext } from "react";

interface TreeContextType {
  defaultExpandAll: boolean;
  expandAll: boolean;
  showLines: boolean;
  disabled: boolean;
}

const defaultValue: TreeContextType = {
  defaultExpandAll: false,
  expandAll: false,
  showLines: false,
  disabled: false
};

export const TreeContext = createContext<TreeContextType>(defaultValue);

export const TreeProvider = TreeContext.Provider;
